import { render } from "./LocationHeadline.vue?vue&type=template&id=609ca74c"
import script from "./LocationHeadline.vue?vue&type=script&lang=js"
export * from "./LocationHeadline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__